export default {
    // Added Sep. 30, 2024
    ENABLE_SCROLL_DRIVEN_NEWSLETTER_MODAL: 'enable-scroll-driven-newsletter-modal',
};